// extracted by mini-css-extract-plugin
export default {"content":"Remove_content__TINaJ"};